import { render, staticRenderFns } from "./BetslipLottoItem.vue?vue&type=template&id=24d3f48d"
import script from "./BetslipLottoItem.vue?vue&type=script&lang=js"
export * from "./BetslipLottoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports